import React, { memo } from "react";

import NoData from "../../common-components/no-data";
import InsurancePremiumPortfolioTable from "./insurance-premium-portfolio-table";
import InsurancePremiumPortfolioChart from "./insurance-premium-portfolio-chart";
import { ArticleContainer, SectionContainer } from "../../clients-dashboard-style";
import { IGetInsurancePremiumPortfolioData } from "../../../../../services/ClientsDashboardServices.dto";
import { UseGenerateDataError } from "../../hooks/useGenerateData.types";

interface InsurancePremiumPortfolioDashboardProps {
  data: IGetInsurancePremiumPortfolioData | null;
  error: UseGenerateDataError;
}

const areEqual = (
  prevProps: InsurancePremiumPortfolioDashboardProps,
  nextProps: InsurancePremiumPortfolioDashboardProps
) => {
  const isEqualData = JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  const isEqualErrorMessage = prevProps.error.insurancePremiumPortfolio === nextProps.error.insurancePremiumPortfolio;
  return isEqualData && isEqualErrorMessage;
};

const InsurancePremiumPortfolioDashboard = memo(({ data, error }: InsurancePremiumPortfolioDashboardProps) => {
  if (error.insurancePremiumPortfolio) {
    return <NoData message={error.insurancePremiumPortfolio} />;
  }

  if (!data || Object.keys(data).length < 1) {
    return <NoData message="Genera una búsqueda para mostrar datos" />;
  }

  if (!data.lstDatos || data.lstDatos.length <= 0) {
    return <NoData message="No existen datos para las fechas seleccionadas" />;
  }

  return (
    <SectionContainer>
      <ArticleContainer>
        <InsurancePremiumPortfolioTable data={data} />
      </ArticleContainer>
      <ArticleContainer>
        <InsurancePremiumPortfolioChart data={data} />
      </ArticleContainer>
    </SectionContainer>
  );
}, areEqual);

export default InsurancePremiumPortfolioDashboard;
